import { useBalance } from "wagmi";
import { contractAddresses } from "../../../../meta";
import { Card, Typography, FlexCol, Divider } from "../../../../shared";
import { displayTokens } from "../../../../utils";
import { useGetContractBalanceByToken } from "../../../state/erc20/useGetContractBalanceByToken";
import { HorizontalRow } from "../components/HorizontalRow/HorizontalRow";

export const TreasuryBalances = () => {
  const ethData = useBalance({ address: contractAddresses.Treasury });

  const { displayData: rwDisplayValueCHI } = useGetContractBalanceByToken(
    "CHI",
    contractAddresses.Treasury
  );
  const { displayData: rwDisplayValueStETH } = useGetContractBalanceByToken(
    "stETH",
    contractAddresses.Treasury
  );
  const { displayData: rwDisplayValueUSC } = useGetContractBalanceByToken(
    "USC",
    contractAddresses.Treasury
  );
  const { displayData: rwDisplayValueWETH } = useGetContractBalanceByToken(
    "WETH",
    contractAddresses.Treasury
  );

  return (
    <Card hasBorder className="p-4">
      <Typography>Treasury/</Typography>
      <br />
      <FlexCol className="gap-2">
        <HorizontalRow
          name="ETH balance"
          value={displayTokens(ethData?.data?.value, {})}
          isFetched={ethData.isFetched}
        />
        <Divider />
        <HorizontalRow name="CHI balance" {...rwDisplayValueCHI} />
        <Divider />
        <HorizontalRow name="stETH balance" {...rwDisplayValueStETH} />
        <Divider />
        <HorizontalRow name="USC balance" {...rwDisplayValueUSC} />
        <Divider />
        <HorizontalRow name="WETH balance" {...rwDisplayValueWETH} />
      </FlexCol>
    </Card>
  );
};
